(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["winter-light-collector"] && !Shopify.designMode) return;
  try {
    
(function(){
  var FLOOR = 340; // never collapse below this
  function docTop(el){ var t=0; while(el){ t+=el.offsetTop; el=el.offsetParent; } return t; }
  function fit(){
    var nodes = document.querySelectorAll('.wl-hero[data-fit="true"]');
    for (var i=0; i<nodes.length; i++){
      var el = nodes[i];
      var extra = parseInt(el.getAttribute('data-extra'), 10) || 0;
      var avail = window.innerHeight - docTop(el) - extra;
      el.style.minHeight = Math.max(avail, FLOOR) + 'px';
    }
  }
  var timer;
  function debounced(){ clearTimeout(timer); timer = setTimeout(fit, 120); }

  if (document.readyState !== 'loading') fit();
  else document.addEventListener('DOMContentLoaded', fit);
  window.addEventListener('load', fit);
  window.addEventListener('resize', debounced);
  window.addEventListener('orientationchange', debounced);
  // Theme editor + late web-font load
  document.addEventListener('shopify:section:load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();

  } catch(e) { console.error(e); }
})();
})();
